import { Component } from '@angular/core';
import { ComponentsModule } from '@mastechnicaegroup/carelinelive-ui';

@Component({
    selector: 'app-client-documents-tab',
    imports: [
        ComponentsModule
    ],
    templateUrl: './client-documents-tab.component.html',
    standalone: true,
    styleUrl: './client-documents-tab.component.scss'
})
export class ClientDocumentsTabComponent {

}
